import request from "root/js/request";

export const getKeywordsPositionLimits = async () => {
  const response = await request({
    url: `/parsers/keywords_position/limits/`,
    method: "get",
  });
  return response;
};
// Выше неверное название и возвращается неверно
export const getParsersKeywordsPositionLimits = async () => {
  const response = await request({
    url: `/parsers/keywords_position/limits/`,
    method: "get",
  });
  return response.data;
};
